import { render, staticRenderFns } from "./Danbu.vue?vue&type=template&id=7fcb4e68&scoped=true"
import script from "./Danbu.vue?vue&type=script&lang=js"
export * from "./Danbu.vue?vue&type=script&lang=js"
import style0 from "./Danbu.vue?vue&type=style&index=0&id=7fcb4e68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb4e68",
  null
  
)

export default component.exports